import Toastification, { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Toastification, {
        timeout: 2000,
    });
    
    // Make toast available via nuxtApp
    return {
        provide: {
            toast: useToast()
        }
    };
});